import React from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import SEO from "react-seo-component";
import "./style.scss";

// Components
import { Loading } from "@atoms";
import TabBar from '@src/componentsNew/TabBar';
import { PAGE_FOR_STATIC_PAGE } from "@components/pages/StaticPage/queries";
import { pageForStaticPage } from "@components/pages/StaticPage/__generated__/pageForStaticPage";

import { baseUrl, offersUrl, mobileMainMgsTabUrl } from "@src/app/routes";

const tabItems = [
  { name: 'For You', url: baseUrl },
  { name: 'Offers', url: offersUrl },
  { name: 'MGS', url: mobileMainMgsTabUrl },
];

const MobileMgsPage = () => {
  const history = useHistory();

  const { data, error, loading } = useQuery<pageForStaticPage>(PAGE_FOR_STATIC_PAGE, {
    variables: { slug: "mgs-open" },
  });

  const handleTabChange = (event, newValue) => {
    history.push(tabItems[newValue].url);
  };

  return (
    <div className="mobile-mgs-wrapper">
      <SEO
        title={data?.page?.seoTitle || ""}
        titleTemplate={data?.page?.seoTitle || ""}
        description={data?.page?.seoDescription || ""}
        pathname=""
        siteLanguage="en"
        siteLocale="en_GB"
        twitterUsername=""
      />
      <TabBar tabItems={tabItems} selectedTab={2} onTabChange={handleTabChange} />
      {
        (loading || !data?.page?.content) ?
          <Loading /> : <div className="mgs-content-wrapper" dangerouslySetInnerHTML={{ __html: data?.page?.content }} />
      }
    </div>
  )
};

export default MobileMgsPage;